<template>
  <div class="order-page">
    <van-nav-bar class="title"
                 @click-left="handleBack"
                 left-arrow>
      <div slot="title">
        <span>保存预报</span>
      </div>
    </van-nav-bar>
    <div class="content">
      <v-form ref="form"
              v-model="valid"
              lazy-validation>
        <!-- <div class="input-item">
          <div class="label">
            <span class="required">*</span>
            渠道名称
          </div>
          <v-select v-model="form.prdName"
                    :rules="[value => !!value || '请选择渠道名称']"
                    :items="channelList"
                    hide-details="auto"
                    placeholder="请选择渠道名称"></v-select>
        </div> -->
        <div class="input-item"
             >
          <div class="label">
            <span class="required">*</span>
            渠道名称
          </div>
          <v-text-field class="customer-input"
                        :value="form.prdName"
                        readonly
                        :rules="[value => !!value || '请选择渠道名称']"
                        dense @click="handleSelectChannel"
                        hide-details="auto"
                        placeholder="请选择渠道名称">
          </v-text-field>
          <van-popup v-model="showPicker" round position="bottom">
            <van-search v-model="pd" @input="searchPrd" placeholder="请输入搜索关键词" />
            <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm"/>
          </van-popup>
          <van-icon name="arrow"
                    size="18"
                    class="right-arrow"
                    color="#9e9e9e" />
        </div>
        <div class="input-item"
             @click="handleSelectCustomer">
          <div class="label">
            <span class="required">*</span>
            客户名称
          </div>
          <v-text-field class="customer-input"
                        :value="form.custName"
                        readonly
                        :rules="[value => !!value || '请选择客户']"
                        dense
                        hide-details="auto"
                        placeholder="请选择客户"></v-text-field>
          <van-icon name="arrow"
                    size="18"
                    class="right-arrow"
                    color="#9e9e9e" />
        </div>
        <div class="input-item" @click="getWarehouseList">
          <div class="label">
            <span class="required">*</span>
            交货仓库
          </div>
          <v-select v-model="form.deliverywareCode"
                    :rules="[value => !!value || '请选择交货仓库']"
                    :items="warehouseList"
                    hide-details="auto"
                    placeholder="请选择交货仓库"></v-select>
        </div>
        <div class="input-item">
          <div class="label">
            <span class="required">*</span>
            仓库代码
          </div>
          <v-text-field class="customer-input"
                        v-model="form.warehouseCode"
                        readonly
                        dense
                        :rules="[value => !!value || '请输入仓库代码']"
                        @click="handleSelectFBA"
                        hide-details="auto"
                        placeholder="请输入仓库代码"></v-text-field>
          <van-popup v-model="showPickerWhc" round position="bottom">
            <van-search v-model="whc" @input="searchWhc" placeholder="请输入搜索关键词" />
            <van-picker show-toolbar :columns="columnsWhc" @cancel="showPickerWhc = false" @confirm="onConfirmWhc"/>
          </van-popup>
          <van-icon name="arrow"
                    size="18"
                    class="right-arrow"
                    color="#9e9e9e" />
        </div>
        <div class="input-item">
          <div class="label">
            邮编
          </div>
          <v-text-field v-model="form.zipcode"
                        dense
                        hide-details="auto"
                        placeholder="请输入邮编"></v-text-field>
        </div>
        <div class="input-item">
          <div class="label">
            <span class="required">*</span>
            体积
          </div>
          <v-text-field :rules="[value => !!value || '请输入体积']"
                        v-model.number="form.volume"
                        hide-details="auto"
                        dense
                        placeholder="请输入体积">
          </v-text-field>
        </div>
        <div class="input-item">
          <div class="label">
            <span class="required">*</span>
            到仓时间
          </div>
          <v-menu v-model="dateMenuShow"
                  content-class="dateMenuCenter"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="auto"
                  fixed>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="form.deliverywareDate"
                            :rules="[value => !!value || '请选择到仓时间']"
                            hide-details="auto"
                            placeholder="请选择到仓时间"
                            readonly
                            v-bind="attrs"
                            v-on="on">
              </v-text-field>
            </template>
            <v-date-picker v-model="form.deliverywareDate"
                           :first-day-of-week="1"
                           :day-format="dayFormat"
                           no-title
                           scrollable
                           @input="dateMenuShow = false">
            </v-date-picker>
          </v-menu>
        </div>
        <div class="input-item">
          <div class="label">
            <span class="required">*</span>
            报关件
          </div>
          <v-radio-group v-model="form.ifCustoms"
                         :rules="[value => !!value || '请选择报关件']"
                         dense
                         hide-details="auto"
                         :column="false">
            <v-radio label="是"
                     value="0"></v-radio>
            <v-radio label="否"
                     value="1"></v-radio>
          </v-radio-group>
        </div>
        <div class="input-item">
          <div class="label">
            <span class="required">*</span>
            是否接受升舱
          </div>
          <v-radio-group v-model="form.note"
                         :rules="[value => !!value || '请选择是否升舱']"
                         dense
                         hide-details="auto"
                         :column="false">
            <v-radio label="是"
                     value="0"></v-radio>
            <v-radio label="否"
                     value="1"></v-radio>
          </v-radio-group>
        </div>
        <div class="input-item">
          <div class="label">
            备注
          </div>
          <v-text-field v-model.number="form.remark"
                        dense
                        hide-details="auto"
                        placeholder="请输入备注"></v-text-field>
        </div>
      </v-form>
    </div>
    <div class="content-bottom">
      <v-btn class="submit"
             :loading="loading"
             :disabled="loading"
             @click="handleSubmit">
        提交
      </v-btn>
    </div>
    <v-dialog v-model="selectDialog"
              content-class="select-dialog"
              max-width="600"
              max-height="800">
      <customer-list v-if="selectDialog"
                     @change="selectDialog = false"
                     :userList="userList" />
    </v-dialog>
    <v-dialog v-model="selectChannelDialog"
              content-class="select-dialog"
              max-width="600"
              max-height="800">
      <channel-list v-if="selectChannelDialog"
                     @change="selectChannelDialog = false"
                     :userList="channelList" />
    </v-dialog>
  </div>
</template>
<script>
import {
  getWarehouseList
} from "@/api/api.js";
import {
  addPrediction,
  getCustomerListAll,
  editPrediction,
  getChannelList,
    selectFBA
} from "@/api/newApi.js";
import {selecttransit} from '@/api/customer/index'
import CustomerList from "./components/customer-list.vue";
import ChannelList from "./components/channel-list.vue";
import { Dialog } from 'vant';
import {getCurrentCycleChannelList} from "../../api/channel";
import {getCustomerInfoPage} from "../../api/customer";

export default {
  name: "save",
  components: {
    CustomerList,
    ChannelList,
  },
  data: () => ({
    id: "",
    valid: true,
    loading: false,
      showPicker:false,
      columns:[],
      pd:'',
    form: {
      "custName": "", // 客户名称
      "deliverywareCode": "",
      "deliverywareDate": "",
      "ifCustoms": "", // 是否报关
      "note": "", // 是否接受升舱
      "prdId": "",
      "prdName": "",
      "remark": "", // 备注
      "volume": "", // 体积
      "warehouseCode": "", // 仓库代码
      "zipcode": "",// 邮编
    },
    channelList: [],// 渠道列表
    warehouseList: [],
    editInfo: {},
    dateMenuShow: false,
    selectDialog: false,
    userList: [],
    selectChannelDialog:false,
      showPickerWhc:false,
      whc:"",
      columnsWhc:[],
      channelOption:[]

  }),
  computed: {
    selectCustomerForSave () {
      return this.$store.getters.selectCustomerForSave
    },
    setSelectChannelForSave () {
      return this.$store.getters.selectChannelForSave
    }
  },
  watch: {
    selectCustomerForSave: {
      handler (val) {
        if (val) {
          this.$store.dispatch("setSelectCustomerForSave", "")
          this.form.custName = val;
        }
      },
      immediate: true
    },
    setSelectChannelForSave: {
      handler (val) {
        if (val) {
          this.$store.dispatch("setSelectChannelForSave", null)
          this.form.prdName = val.prdName;
          this.form.prdId = val.prdId;
        }
      },
      immediate: true
    }
  },
  created () {
    let form = sessionStorage.getItem("saveForm");
    form = JSON.parse(form);
    if (form) {
      delete form.custName;
      this.form = {
        ...this.form,
        ...form
      }
      sessionStorage.removeItem("saveForm");
    }
  },
  mounted () {
    this.id = this.$route.query.id;
    this.getChannelList();
    this.getWarehouseList();
    this.getCustomerListAll()
    if (this.id) {
      let str = localStorage.getItem("forecastItem");
      if (str) {
        try {
          let form = JSON.parse(str);
          this.editInfo = form;
          for (const key in this.form) {
            if (Object.hasOwnProperty.call(this.form, key)) {
              this.form[key] = form[key];
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    }

  },
  methods: {

      getPdList(prdName){
        this.columns = [];
          getCurrentCycleChannelList()
              .then(resp => {
                  this.channelOption = resp.data;
                  for(var i = 0;i<resp.data.length;i++){
                      if(resp.data[i].channelName.indexOf(prdName)!==-1){
                          this.columns.push(resp.data[i].channelName);
                      }
                  }
              })
      },

      getWhcList(name){
          this.columnsWhc = [];
          selectFBA({name:name,pageSize:9999})
              .then(resp => {
                  for(var i = 0;i<resp.data.records.length;i++){
                      this.columnsWhc.push(resp.data.records[i].name);
                  }
                  this.columnsWhc.push("待定");
              })
      },

      searchWhc(){
          this.getWhcList(this.whc);
      },

      searchPrd(){
          this.getPdList(this.pd);
      },
      onConfirm(value){
          this.form.prdName = value;
          this.channelOption.map((shit) => {
              if(shit.channelName===value){
                  this.form.prdId = shit.channelId;
              }
          })
          this.showPicker = false;
      },

      onConfirmWhc(value){
          this.form.warehouseCode = value;
          this.showPickerWhc = false;
      },

    handleBack () {
      this.$router.back();
    },
    handleSubmit () {
          if(parseFloat(this.form.volume)>=30){
              Dialog.confirm({
                  title: '是否已分票',
                  confirmButtonText:"是",
                  cancelButtonText:'否'
              })
                  .then(() => {
                      if (!this.$refs.form.validate()) return;
                      let form = { ...this.form };
                      form.status = "0";
                      let fn = addPrediction;
                      if (this.id) {
                          fn = editPrediction;
                          form.id = this.editInfo.id;
                      }
                      this.loading = true;
                      fn(form).then((res) => {
                          this.$toast("保存成功")
                          this.loading = false;
                          setTimeout(() => {
                              this.$router.replace("/order")
                          }, 1500);
                      }).catch((err) => {
                          this.loading = false;
                          console.log(err);
                          this.$toast(err?.msg || "保存失败!请重试")
                      });
                  })
                  .catch(() => {
                      this.loading = false;
                      this.$toast("请与渠道沟通确认");
                      setTimeout(() => {
                          this.$router.replace("/order")
                      }, 1500);
                  });
          }else {
              if (!this.$refs.form.validate()) return;
              let form = { ...this.form };
              form.status = "0";
              let fn = addPrediction;
              if (this.id) {
                  fn = editPrediction;
                  form.id = this.editInfo.id;
              }
              this.loading = true;
              fn(form).then((res) => {
                  this.$toast("保存成功")
                  this.loading = false;
                  setTimeout(() => {
                      this.$router.replace("/order")
                  }, 1500);
              }).catch((err) => {
                  this.loading = false;
                  console.log(err);
                  this.$toast(err?.msg || "保存失败!请重试")
              });
          }
    },
    dayFormat (str) {
      str = str.slice(-2);
      return Number(str)
    },
    // 触发选择客户
    handleSelectCustomer () {
      if (window.screen.width > 520) {
        this.selectDialog = true;
      } else {
        this.$router.push("/customer")
      }
    },
    handleSelectChannel(){
        this.showPicker = true;
        this.getPdList("");
      // if (window.screen.width > 520) {
      //   this.selectChannelDialog = true;
      // } else {
      //   this.$router.push("/channel")
      // }
    },
      handleSelectFBA(){
          this.showPickerWhc = true;
          this.getWhcList("");
      },
    // 获取仓库
    getWarehouseList () {
      // this.loading = true;
      // let param = {
      // }
      // getWarehouseList(param).then((res) => {
      //   let list = res.result || [];
      //   list = list.map(item => {
      //     return {
      //       text: item.name,
      //       value: item.name,
      //     }
      //   })
      //   this.warehouseList = list;
      //   console.dir(list);
      //   this.loading = false;
      // }).catch((err) => {
      //   console.log(err);
      //   let msg = err.msg || "网络异常"
      //   this.$toast(msg)
      //   this.loading = false;
      // });
        selecttransit()
            .then(resp => {
                let list = resp.data || [];
                list = list.map(item => {
                    return {
                        text: item.name,
                        value: item.name,
                    }
                })
                this.warehouseList = list;
            })

    },
    // 获取用户
    getCustomerListAll () {
      let param = {}
        getCustomerInfoPage(param).then((res) => {
        let list = res.data.records || [];
        this.userList = list;
      }).catch((err) => {
        console.log(err);
      });
    },
    // 获取渠道
    getChannelList () {
      let param = {
      }
        getCurrentCycleChannelList(param).then((res) => {
        let list = res.data || [];
        // list = list.map(item => {
        //   return {
        //     text: item.channelName,
        //     value: item.channelName,
        //   }
        // })
        this.channelList = list;
        this.loading = false;
      }).catch((err) => {
        console.log(err);
        let msg = err.msg || "网络异常"
        this.$toast(msg)
        this.loading = false;
      });
    },
  },
  beforeRouteLeave (to, from, next) {
    if (to.path == '/customer') {
      sessionStorage.setItem("saveForm", JSON.stringify(this.form))
      to.meta.keepAlive = true;
    }
    next();
  },
}
</script>
<style lang="scss" scoped>
.order-page {
  position: relative;
  // width:100%;
  height: 100vh;
  background-color: #f5f6fa;
  overflow: hidden;
  overflow-y: auto;
  padding-top: 2.8rem;
  padding-bottom: 4rem;
  font-size: 0.64rem;
  box-sizing: border-box;
  z-index: 1;

  > div:not(.van-popup, .van-nav-bar) {
    position: relative;
    z-index: 1;
  }
}

:deep(.v-input) {
  margin: 0;
  padding: 0;

  input {
    padding: 0.08rem 0 !important;
    text-align: right;
  }

  .v-input__slot {
    &::after,
    &::before {
      display: none;
    }
  }
}

.v-radio {
  margin-left: 0.8rem;
}

.order-page :deep(.v-select__selections) {
  justify-content: flex-end;

  input:last-child {
    flex-grow: 0;
  }

  input:first-child {
    flex: 1;
    margin-top: 0;
    margin-bottom: 0;
  }
}

:deep(.v-list-item__title) {
  font-size: 0.56rem;
}

:deep(.v-messages__message) {
  text-align: right;
}

.v-picker {
  font-size: 0.56rem;
}

// 标题
.title {
  text-align: left;

  :deep(.van-nav-bar__title) {
    margin: 0;
    margin-left: 3rem;
    font-weight: normal;
    font-size: 16px;

    > div {
      display: flex;
      align-items: center;
    }
  }

  :deep(.van-nav-bar__right:active) {
    opacity: 1;
  }

  .btn-list {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    span {
      padding: 0.08rem 0.4rem;
      color: dodgerblue;
      transition: all 0.3;

      &:active {
        opacity: 0.7;
      }
    }
  }
}

.content,
.content-bottom {
  width: 13.72rem;
  margin: 0 auto;
  background: #FFFFFF;
  border-radius: 0.48rem;
}

.content-bottom {
  background: none;
}

.required {
  font-size: 12px;
  color: red;
}

.input-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 0;
  margin: 0 0.4rem 0 0.56rem;
  font-size: 0.56rem;
  color: #333333;
  line-height: 0.56rem;
  border-bottom: 1px solid #E8E8E8;

  .label {
    flex-shrink: 0;
    margin-right: 0.32rem;
  }
}

.v-input.customer-input {
  :deep(input) {
    color: #222;
  }

  :deep(.v-messages__message) {
    color: #ff5252 !important;
    caret-color: #ff5252 !important;
  }
}

.order-page .v-btn.submit {
  display: block;
  margin: 1.2rem auto 0;
  width: 12rem;
  height: 1.6rem;
  line-height: 1.6rem;
  text-align: center;
  background-color: #3890FF;
  color: #fff;
  font-size: 0.64rem;
  border-radius: 4rem;
}

@media screen and (min-width: 500px) {
  .content,
  .content-bottom {
    margin: 0;
    margin-left: 0.64rem;
    width: 90%;
    max-width: 600px;
  }

  .content-bottom {
    /*position: fixed !important;*/
    /*bottom: 50px;*/
  }

  .input-item {
    padding: 20px 10px;
  }

  .order-page .v-btn.submit {
  }
}

:deep(.select-dialog) {
  height: 600px !important;
  max-width: 500px !important;

  .customer-list {
    max-height: 600px !important;
  }

  .van-list {
    max-height: 545px !important;
  }
}
</style>
<style>
.dateMenuCenter.v-menu__content {
  left: 50% !important;
  transform: translateX(-50%);
}
</style>